// extracted by mini-css-extract-plugin
export default {"quickstartsHero":"quickstartsHero---0Uw3","quickstartsHeroImage":"quickstartsHeroImage--9km8e","quickstartsHeroTitle":"quickstartsHeroTitle--8--0F"};